import { mediaQuery } from '~/js/helpers';

document.addEventListener('DOMContentLoaded', () => {
	if (!mediaQuery('lg-up')) {
		return;
	}

	const sections = document.querySelectorAll('.information-links');
	sections.forEach((section) => {
		let maxHeight = 0;
		const elements = section.querySelectorAll('[data-equal-height]');
		elements.forEach((element) => {
			const height = element.offsetHeight;
			if (height > maxHeight) {
				maxHeight = height;
			}
		});
		elements.forEach((element) => {
			element.style.height = `${maxHeight}px`;
		});
	});
});
